

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETADMINDASHBOARD= createAsyncThunk(
  "getAdminDashboard/getAdminDashboard",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAdminDashboardSlice = createSlice({
  name: "getAdminDashboardSlice",
  initialState: {
    getAdminDashboard: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAdminDashboard: (state) => {
        state.getAdminDashboard.loading = false
        state.getAdminDashboard.error = false
        state.getAdminDashboard.data = []
        state.getAdminDashboard.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETADMINDASHBOARD.fulfilled, (state, action) => {
      state.getAdminDashboard = {
        ...state.getAdminDashboard,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETADMINDASHBOARD.pending, (state, action) => {
      state.getAdminDashboard = {
        ...state.getAdminDashboard,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETADMINDASHBOARD.rejected, (state, action) => {
      state.getAdminDashboard = {
        ...state.getAdminDashboard,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAdminDashboardAction = {
    GETADMINDASHBOARD,
};

export { getAdminDashboardAction };
export default getAdminDashboardSlice.reducer;
export const {setInitialStateOfgetAdminDashboard} = getAdminDashboardSlice.actions
